import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { ErrorScreen } from './ErrorScreen/index.js';
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
        };
    }
    componentDidCatch(error) {
        this.setState({ error });
    }
    render() {
        const { children } = this.props;
        const { error } = this.state;
        if (error) {
            const { errorScreenComponent: ErrorScreenComponent = ErrorScreen } = this.props;
            return _jsx(ErrorScreenComponent, { error: error });
        }
        return children;
    }
}
